export const featureConstant = {
	NEW_DESIGN_SYSTEM: "NEW_DESIGN_SYSTEM",
	MULTIDEX: "MULTIDEX",
	ETR_LOGO_RENDERER: "ETR_LOGO_RENDERER",
	BUILDEX_GO_LIVE: "BUILDEX_GO_LIVE",
	NOTIFY_MULTIPLE_ENPOINT: "NOTIFY_MULTIPLE_ENPOINT",
	ETR_IGPNI: "ETR_IGPNI",
	ETR_IGPNI_TR_V5: "ETR_IGPNI_TR_V5",
	DASHBOARD: "DASHBOARD",
	TT_HOTFIX: "TT_HOTFIX",
	ERROR_MESSAGE_ENHANCEMENT: "ERROR_MESSAGE_ENHANCEMENT",
	DASHBOARD_EMBEDDING: "DASHBOARD_EMBEDDING",
	IG_PNI_LEGAL_REQUIREMENTS: "IG_PNI_LEGAL_REQUIREMENTS",
	CUSTOM_HEADER_CONFIGURATION: "CUSTOM_HEADER_CONFIGURATION",
	EMAIL_PREFERENCE: "EMAIL_PREFERENCE",
	SOFT_DELETE_USER: "SOFT_DELETE_USER",
	MASTER_DATA_UPLOAD: "MASTER_DATA_UPLOAD",
	AGENT_PRINCIPAL_UI: "AGENT_PRINCIPAL_UI",
	MASTER_DATA_VALIDATION: "MASTER_DATA_VALIDATION",
	MASTER_DATA_UPLOAD_HDB: "MASTER_DATA_UPLOAD_HDB",
	AGENT_PRINCIPAL_UI_PULL: "AGENT_PRINCIPAL_UI_PULL",
	CONSUMER_BASED_MASTER_DATA_VALIDATION: "CONSUMER_BASED_MASTER_DATA_VALIDATION",
	SUBMITTALS: "SUBMITTALS",
	DSV_ENABLED: "DSV_ENABLED",
	HCI_IMPROVEMENT: "HCI_IMPROVEMENT",
	PAYLOAD_UEN_VALIDATION: "PAYLOAD_UEN_VALIDATION"
}

export const featureFlag = {	
	[featureConstant.ETR_LOGO_RENDERER]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"prod": true
	},
	[featureConstant.NOTIFY_MULTIPLE_ENPOINT]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"prod": true
	},
	[featureConstant.ETR_IGPNI]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"prod": true
	},
	[featureConstant.ETR_IGPNI_TR_V5]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"prod": true
	},
	[featureConstant.TT_HOTFIX]: {
		"local": true,
		"dev": true,
		"test": false,
		"uat": false,
		"pre-prod": true,
		"prod": true
	},
	[featureConstant.IG_PNI_LEGAL_REQUIREMENTS]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"prod": true
	},
	[featureConstant.EMAIL_PREFERENCE]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": false
	},
	[featureConstant.CUSTOM_HEADER_CONFIGURATION]: {
		"local": true,
		"dev": true,
		"test": false,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.SOFT_DELETE_USER]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.MASTER_DATA_UPLOAD]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.AGENT_PRINCIPAL_UI]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.MASTER_DATA_VALIDATION]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.MASTER_DATA_UPLOAD_HDB]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.AGENT_PRINCIPAL_UI_PULL]: {
		"local": false,
		"dev": false,
		"test": false,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.CONSUMER_BASED_MASTER_DATA_VALIDATION]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	},
	[featureConstant.SUBMITTALS]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"prod": false
	}
}
